import { render } from "./JourneySetJourneys.vue?vue&type=template&id=53156116&scoped=true"
import script from "./JourneySetJourneys.vue?vue&type=script&lang=ts"
export * from "./JourneySetJourneys.vue?vue&type=script&lang=ts"

import "./JourneySetJourneys.vue?vue&type=style&index=0&id=53156116&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53156116"

export default script